import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, transition, animate, state, group } from '@angular/animations';
import { Configuration, MultilevelNodes, ListStyle } from './../app.model';
import { CONSTANT } from './../constants';
import { MultilevelMenuService } from '../multilevel-menu.service';

@Component({
  selector: 'ng-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: [ './list-item.component.css' ],
  animations: [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 0 })),
      transition(':leave', [
        style({ height: '*', opacity: 0.2 }),
        group([
          animate(200, style({ height: 0 })),
          animate('200ms ease-out', style({ opacity: 0 }))
        ])
      ]),
      transition(':enter', [
        style({ height: '0', opacity: 0 }),
        group([
          animate(200, style({ height: '*' })),
          animate('400ms ease-out', style({ opacity: 1 }))
        ])
      ])
    ]),
    trigger('isExpandedLTR', [
      state('no', style({ transform: 'rotate(-90deg)' })),
      state('yes', style({ transform: 'rotate(0deg)', })),

      transition('no => yes',
        animate(200)
      ),
      transition('yes => no',
        animate(200)
      )
    ]),
    trigger('isExpandedRTL', [
      state('no', style({ transform: 'rotate(90deg)' })),
      state('yes', style({ transform: 'rotate(0deg)', })),

      transition('no => yes',
        animate(200)
      ),
      transition('yes => no',
        animate(200)
      )
    ])
  ]
})
export class ListItemComponent implements OnChanges {
  @Input() node: MultilevelNodes;
  @Input() level = 1;
  @Input() selectedNode: MultilevelNodes;
  @Input() nodeConfiguration: Configuration = null;
  @Output() selectedItem = new EventEmitter<MultilevelNodes>();
  @Input() visible_label: boolean;
  @Input() expandmenu: boolean;
  isSelected = false;
  nodeChildren: MultilevelNodes[];
  classes: { [ index: string ]: boolean };
  selectedListClasses: { [ index: string ]: boolean };
  expanded = false;
  firstInitializer = false;
  constructor(
    private router: Router,
    private multilevelMenuService: MultilevelMenuService
  ) {
    this.selectedListClasses = {
      [ CONSTANT.DEFAULT_LIST_CLASS_NAME ]: true,
      [ CONSTANT.SELECTED_LIST_CLASS_NAME ]: false,
    };


  }
  ngOnInit(): void {
    //this.visible_label=this.expandmenu;
  }

  ngOnChanges() {

    this.nodeChildren = this.node && this.node.items ? this.node.items.filter(n => !n.hidden) : [];

    if (this.selectedNode !== undefined && this.selectedNode !== null) {
      this.setSelectedClass(this.multilevelMenuService.recursiveCheckId(this.node, this.selectedNode.id));
    }
    /*
       this.multilevelMenuService.exand_menu.subscribe(
          visibleLabel => {
             this.visible_label =visibleLabel;
           }
           );*/
  }
  setSelectedClass(isFound: boolean): void {
    if (isFound) {
      if (!this.firstInitializer) {
        this.expanded = true;
      }
      this.isSelected = (this.node.id === this.selectedNode.id) && (this.nodeConfiguration.highlightOnSelect === false && (this.selectedNode.items === undefined || this.selectedNode.items.length == 0)) ? true : false;
    } else {
      this.isSelected = false;

      if (this.nodeConfiguration.collapseOnSelect) {
        this.expanded = false;

      }
    }
    this.selectedListClasses = {
      [ CONSTANT.DEFAULT_LIST_CLASS_NAME ]: true,
      [ CONSTANT.SELECTED_LIST_CLASS_NAME ]: this.isSelected,
    };

    this.setClasses();
  }
  getPaddingAtStart(): boolean {
    return this.nodeConfiguration.paddingAtStart ? true : false;
  }
  getListStyle(): ListStyle {
    const styles = {
      background: CONSTANT.DEFAULT_LIST_BACKGROUND_COLOR,
      color: CONSTANT.DEFAULT_LIST_FONT_COLOR
    };
    if (this.nodeConfiguration.listBackgroundColor !== null) {
      styles.background = this.nodeConfiguration.listBackgroundColor;
    }
    if (this.isSelected) {
      this.nodeConfiguration.selectedListFontColor !== null ?
        styles.color = this.nodeConfiguration.selectedListFontColor : styles.color = CONSTANT.DEFAULT_SELECTED_FONT_COLOR;
    } else if (this.nodeConfiguration.fontColor !== null) {
      styles.color = this.nodeConfiguration.fontColor;
    }

    if (this.level > 1) {
      // styles.background = '#e7f9ff';
      styles.background = '#4c779b';
      styles.color ='#0b284d !important';
    }

    // if (this.level ===2) {
    //   styles.background ='#7966A6';
    //   //styles.background ='#7c73b3';
    // }
    // if (this.level ===3) {
    //   styles.background ='#9d96c6';
    // }

    // if (this.level > 3) {
    //   styles.background ='#bdb9d9';
    // }

    return styles;
  }
  getListIcon(node: MultilevelNodes): string {
    if (node.icon !== null && node.icon !== undefined && node.icon !== '') {
      return `icon`;
    } else if (node.faIcon !== null && node.faIcon !== undefined && node.faIcon !== '') {
      return `faicon`;
    } else if (node.imageIcon !== null && node.imageIcon !== undefined && node.imageIcon !== '') {
      return `imageicon`;
    } else {
      return ``;
    }
  }
  hasItems(): boolean {
    return this.nodeChildren.length > 0 ? true : false;
  }
  isRtlLayout(): boolean {
    return this.nodeConfiguration.rtlLayout;
  }
  setClasses(): void {
    this.classes = {
      [ 'level-' + this.level ]: true,
      'amml-submenu': this.hasItems() && this.getPaddingAtStart()
    };
  }
  expand(node: MultilevelNodes): void {



    this.expanded = !this.expanded;
    this.firstInitializer = true;
    this.setClasses();

    if (this.nodeConfiguration.interfaceWithRoute !== null
      && this.nodeConfiguration.interfaceWithRoute
      && node.link !== undefined
      && node.link
    ) {
      if (node.externalRedirect !== undefined && node.externalRedirect) {
        //window.location.href = node.link;
        window.open(node.link, "_blank")    
      } else {
        const urlSplit = node.link.split('?');
        const url = urlSplit[ 0 ]
        if (urlSplit.length == 1) {
          this.router.navigate([ url ]);
        } else {
          this.router.navigate([ url ], { queryParams: this.convertQueryParamsStringToJson(urlSplit[ 1 ]) });
        }
      }
    }
    else if (node.onSelected && typeof node.onSelected === 'function') {
      node.onSelected(node);
      this.selectedListItem(node);
    } else if (node.items === undefined || this.nodeConfiguration.collapseOnSelect) {
      this.selectedListItem(node);
    }

    this.multilevelMenuService.expandTrue(); // menu expandido
  }
  selectedListItem(node: MultilevelNodes): void {
    this.selectedItem.emit(node);
  }

  convertQueryParamsStringToJson = (queryParams) => {
    return queryParams.split('&')
      .map(p => p.split('='))
      .reduce((obj, pair) => {
        const [ key, value ] = pair.map(decodeURIComponent);
        return ({ ...obj, [ key ]: value })
      }, {});
  }

}
